import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';
import { PathRoutes } from 'src/const/Routes/PathRoutes';
import styles from './Header.module.scss';

export const Header = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div
          className={styles.arrow}
          onClick={() => navigate(PathRoutes.ProfileRoute)}
        >
          <KeyboardBackspaceIcon sx={{ color: 'black' }} />
        </div>
        <div className={styles.title}>Create Circle</div>
      </div>
    </div>
  );
};
